import axiosInstance from "@/utils/axiosInstance";

const baseUrl: string = "api/connectors/pappers";

const state = {};

const getters = {};

const mutations = {};

const actions = {
  async getEntreprise({commit}, payload: {
    siret: string,
  }): Promise<any> {
    return axiosInstance.get(`${baseUrl}/entreprise`, {
      params: {
        siret: payload.siret,
      },
    }).then((data) => data.data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
